import { datadogLogs, type LogsEvent } from '@datadog/browser-logs';
import { v4 } from 'uuid';

const isProd = import.meta.env.PROD;

const getServiceName = () => `control-center-web-${import.meta.env.VITE_ENV_CONFIG}`;

const getAccountName = () => `man-control-center-${import.meta.env.VITE_ENV_CONFIG}`;

if (isProd) {
    datadogLogs.init({
        clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
        env: import.meta.env.VITE_ENV_CONFIG,
        forwardErrorsToLogs: true,
        forwardConsoleLogs: ['info'],
        site: import.meta.env.VITE_DATADOG_SITE,
        sessionSampleRate: 100,
        service: getServiceName(),
        beforeSend: (event: LogsEvent) => {
            if (event.view) {
                if (event.view.url) {
                    event.view.url = event.view.url.replace(/access_token=[^&]*/, 'access_token=REDACTED');
                    event.view.url = event.view.url.replace(/id_token=[^&]*/, 'id_token=REDACTED');
                }
                if (event.view.referrer) {
                    event.view.referrer = event.view.referrer.replace(/access_token=[^&]*/, 'access_token=REDACTED');
                    event.view.referrer = event.view.referrer.replace(/id_token=[^&]*/, 'id_token=REDACTED');
                }
            }
            if (event.http && event.http.url) {
                event.http.url = event.http.url.replace(/access_token=[^&]*/, 'access_token=REDACTED');
                event.http.url = event.http.url.replace(/id_token=[^&]*/, 'id_token=REDACTED');
            }
            if (event.message) {
                event.message = event.message.replace(/access_token=[^&]*/, 'access_token=REDACTED');
                event.message = event.message.replace(/id_token=[^&]*/, 'id_token=REDACTED');
            }
            if (event.error && event.error.stack) {
                event.error.stack = event.error.stack.replace(/access_token=[^&]*/, 'access_token=REDACTED');
                event.error.stack = event.error.stack.replace(/id_token=[^&]*/, 'id_token=REDACTED');
            }
            return true;
        },
    });

    const teamName = 'man_control_center';

    datadogLogs.setGlobalContext({
        account_id: import.meta.env.VITE_ACCOUNT_ID,
        team_identifier: import.meta.env.VITE_TEAM_IDENTIFIER,
        account_name: getAccountName(),
        team: teamName,
        'datadog.index': import.meta.env.VITE_TEAM_IDENTIFIER,
    });
}

export const getSessionID = (): string => {
    let sessionId = localStorage.getItem('sessionId');
    if (!sessionId) {
        sessionId = v4();
        localStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
};

export const logPageViews = (pageName: string, sessionId: string) => {
    datadogLogs.logger.info('Page viewed', {
        page: pageName,
        sessionId,
    });
};

export const logTerminatedSession = (sessionId: string) => {
    datadogLogs.logger.info(`Session terminated at ${import.meta.env.VITE_ENV_CONFIG}`, {
        page: 'Control center',
        sessionId,
    });
};
